import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_STARTER_DM_RECOMMENDER = createFcmDetails('starfish_starter_dm_recommender', {
	owner: 'starfish',
	context: 'Starter Dashboard page',
	description: 'Feature release flag that enables decision maker recommendations on the starter dashboard',
	import: false,
	mergeLogic: 'Checks `locale` and `countryCode` to determine value. Both must be `true` for the feature to be enabled',
});
